import(/* webpackMode: "eager" */ "/codebuild/output/src2996922085/src/atua-frontend/src/app/page.tsx");
